import { SSO_API_URL } from '@src/configs';
import api from './api';

const logoutAllSessions = async () => {
  const response = await api({
    method: 'DELETE',
    url: `${SSO_API_URL}/api/v1/sessions`,
  });
  return response;
};

export { logoutAllSessions };
